import {Dictionaries} from '../Translator';
import {Language} from '../Language';
import dictionaryEN from './en';
import dictionaryES from './es';
import dictionaryDE from './de';
import dictionaryFR from './fr';
import dictionaryFI from './fi';
import dictionaryHU from './hu';
import dictionaryIT from './it';
import dictionaryJP from './jp';
import dictionaryKO from './ko';
import dictionaryNL from './nl';
import dictionaryNO from './no';
import dictionaryPL from './pl';
import dictionaryPT from './pt';
import dictionaryRO from './ro';
import dictionaryRU from './ru';
import dictionarySL from './sl';
import dictionarySV from './sv';
import dictionaryTR from './tr';
import dictionaryCN from './cn';
import dictionaryCZ from './cz';
import dictionaryDA from './da';

export default {
  [Language.CN]: dictionaryCN,
  [Language.CZ]: dictionaryCZ,
  [Language.EN]: dictionaryEN,
  [Language.DA]: dictionaryDA,
  [Language.DE]: dictionaryDE,
  [Language.ES]: dictionaryES,
  [Language.FR]: dictionaryFR,
  [Language.FI]: dictionaryFI,
  [Language.HU]: dictionaryHU,
  [Language.IT]: dictionaryIT,
  [Language.JP]: dictionaryJP,
  [Language.KO]: dictionaryKO,
  [Language.NL]: dictionaryNL,
  [Language.NO]: dictionaryNO,
  [Language.PL]: dictionaryPL,
  [Language.PT]: dictionaryPT,
  [Language.RO]: dictionaryRO,
  [Language.RU]: dictionaryRU,
  [Language.SL]: dictionarySL,
  [Language.SV]: dictionarySV,
  [Language.TR]: dictionaryTR,
} as Dictionaries;
